import { render, staticRenderFns } from "./subOptionElect.vue?vue&type=template&id=4f24b5c0&scoped=true&"
import script from "./subOptionElect.vue?vue&type=script&lang=js&"
export * from "./subOptionElect.vue?vue&type=script&lang=js&"
import style0 from "./subOptionElect.vue?vue&type=style&index=0&id=4f24b5c0&scoped=true&lang=css&"
import style1 from "./subOptionElect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f24b5c0",
  null
  
)

export default component.exports